var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "permission-calendar data-load",
      class: { "sk-loading": _vm.showSpinner },
    },
    [
      _vm.showSpinner ? _c("sk-spinner") : _vm._e(),
      _c("h4", [_vm._v(_vm._s(_vm.title))]),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-title m-0 border-bottom" }, [
          _c(
            "a",
            {
              staticClass: "p-2 float-right btn-refresh",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.refreshButtonClicked.apply(null, arguments)
                },
              },
            },
            [_c("i", { staticClass: "fas fa-sync-alt" })]
          ),
        ]),
        _c("div", { staticClass: "card-body p-0" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-6 col-md-6 col-lg-6" },
              [
                _c("suc-date-period-component", {
                  staticClass: "m-2",
                  attrs: { type: _vm.type },
                  on: _vm._d({}, [_vm.periodChangedEvent, _vm.periodChanged]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-6 col-md-6 col-lg-6" },
              [_vm._t("calendar-right")],
              2
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "row mt-1" }, [
        _c("div", { staticClass: "col table-responsive" }, [
          _c(
            "table",
            { staticClass: "table text-center table-without-border" },
            [
              _c("thead", [
                _c("tr", [
                  _c("td", { staticClass: "p-0" }, [
                    _vm._v(_vm._s(_vm.$t("components.date.day_short[0]"))),
                  ]),
                  _c("td", { staticClass: "p-0" }, [
                    _vm._v(_vm._s(_vm.$t("components.date.day_short[1]"))),
                  ]),
                  _c("td", { staticClass: "p-0" }, [
                    _vm._v(_vm._s(_vm.$t("components.date.day_short[2]"))),
                  ]),
                  _c("td", { staticClass: "p-0" }, [
                    _vm._v(_vm._s(_vm.$t("components.date.day_short[3]"))),
                  ]),
                  _c("td", { staticClass: "p-0" }, [
                    _vm._v(_vm._s(_vm.$t("components.date.day_short[4]"))),
                  ]),
                  _c("td", { staticClass: "p-0" }, [
                    _vm._v(_vm._s(_vm.$t("components.date.day_short[5]"))),
                  ]),
                  _c("td", { staticClass: "p-0" }, [
                    _vm._v(_vm._s(_vm.$t("components.date.day_short[6]"))),
                  ]),
                ]),
              ]),
              _c(
                "tbody",
                _vm._l(_vm.preparedData, function (row, row_index) {
                  return _c(
                    "tr",
                    { key: row_index },
                    _vm._l(row, function (cell, cell_index) {
                      return _c(
                        "td",
                        {
                          key: row_index + "_" + cell_index,
                          staticClass: "p-0",
                        },
                        [
                          _vm._t(
                            "cell",
                            function () {
                              return [
                                _vm._v(" " + _vm._s(cell.day.getDate()) + " "),
                              ]
                            },
                            { cell: cell }
                          ),
                        ],
                        2
                      )
                    }),
                    0
                  )
                }),
                0
              ),
              _c("tfoot", [_vm._t("foot")], 2),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }